module.exports = __webpack_public_path__ + "img/ico_ns_support.8c7702b2.svg";